import { createContext } from "react";

export const ClickSection = createContext("app");
